import React, { Component } from "react";
import "./NewIcon.scss";
class NewIcon extends Component {
  render() {
    const { className, isMobile } = this.props;
    return (
      <div className={`new-icon-copmonent ${className} ${isMobile ? "mo" : ""}`}>
        <img className="" alt="new-template" src="https://front.videomonster.com/images-u6yd72dy/common/new-icon.svg"/>
      </div>
    );
  }
}

export default NewIcon;
